import Document from "@tiptap/extension-document";
import {PRINTOUT_FOOTER_NODE_NAME, PRINTOUT_HEADER_NODE_NAME} from "./printoutRegionOptions";

// Header and footer positions are schema invariants; both remain optional.
export const PrintoutDocumentNode = Document.extend({
    // Keep a paragraph as the default at body positions (used by Tiptap's clearNodes).
    content: `${PRINTOUT_HEADER_NODE_NAME}? (block+ ${PRINTOUT_FOOTER_NODE_NAME} | block+)`,

    addAttributes() {
        return {
            headingFontFamily: {default: null, rendered: false},
        };
    },
});
